import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
    NoteBruger,
    NoteHenvendelsestype,
    NoteOmraade,
    NoteOmraader,
    NoteOpgavestyringStatus,
    NoteRepository
} from "@e-forsyning/common/note";

@Injectable({ providedIn: "root" })
export class MaalerskiftNoteService {
    constructor(private readonly noteRepository: NoteRepository) {}

    public hentNoteOmraader(): Observable<NoteOmraade[]> {
        return this.noteRepository
            .hentOmraader()
            .pipe(map((omraader: NoteOmraade[]) => omraader.filter(o => o.key === NoteOmraader.installation)));
    }

    public hentNoteHenvendelsestyper(): Observable<NoteHenvendelsestype[]> {
        return this.noteRepository.hentHenvendelsestyper().pipe(
            map((henvendelsestyper: NoteHenvendelsestype[]) => {
                const result = henvendelsestyper.filter(t => t.value === "Målerskift");
                return result.length !== 0 ? result : henvendelsestyper;
            })
        );
    }

    public hentNoteOpgavestyringStatusser(): Observable<NoteOpgavestyringStatus[]> {
        return this.noteRepository.hentOpgavestyringStatusser();
    }

    public hentNoteBrugere(): Observable<NoteBruger[]> {
        return this.noteRepository.hentBrugere();
    }

    public get defaultNoteOmraadeId(): number {
        return NoteOmraader.installation;
    }
}
